import { Component, Input } from '@angular/core';
import { ORDER_DELIVERY_METHODS } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-delivery-type-icon',
  templateUrl: './ui-delivery-type-icon.component.html',
  styleUrls: ['./ui-delivery-type-icon.component.scss']
})
export class UiDeliveryTypeIconComponent {
  @Input() type: string;

  public get types() {
    return ORDER_DELIVERY_METHODS;
  }
}
